import { render } from "./ProdutToPrices.vue?vue&type=template&id=2220e9f6&ts=true"
import script from "./ProdutToPrices.vue?vue&type=script&lang=ts"
export * from "./ProdutToPrices.vue?vue&type=script&lang=ts"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__